module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-fcbaa7205af306fd320dd11550bed580.png";